<div class="container" role="main" aria-label="agreementForm">
  <form
    class="agreementForm"
    [formGroup]="agreementForm"
    (ngSubmit)="agreementDetailsSubmit()"
  >
    <div class="row">
      <div class="row HmsInsideContainer">
          <div class="col-md-12 button-padding-left-custom">
              <button type="button" class="greyBtn" (click)="back()"  style="font-weight : bold;"><b>Go to Previous Section</b></button>
              <button type="button" class="greyBtn ml-2" (click)="openInstruction()"
                  style="margin-left: 1rem;font-weight : bold;"><b>Instructions</b></button>
            <button
              type="submit"
              class="orangeBtn ml-5" [disabled]="submitClicked"
              [ngStyle]="{'background-color': !submitClicked ? primaryColor : 'gray'}"
            >
              Submit Referral
            </button>
          </div>
      </div>

      <div class="row HmsInsideContainer">
          <div class="col-md-12" style="display: flex;">
              <span class="exclamation-icon">!</span><p role="heading" class="margin-none" aria-level="1">Please review the summary of the information entered for this referral. Please ensure you click "Submit Referral". Your referral is successfully submitted when you land on the confirmation page. If you exit prior to receiving the confirmation page, this may result in the referral not being submitted.</p>
          </div>
      </div>

      <div class="row HmsInsideContainer">
          <div class="col-md-12">
              <p role="heading" class="margin-none" aria-level="1">Submitting Party Information</p>
          </div>
      </div>
      
      <div class="row HmsInsideContainer">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <app-json-preview [controlsData]="userFormData.controls">
            </app-json-preview>
        </div>
      </div>

      
      <div class="row HmsInsideContainer">
          <div class="col-md-12">
              <p role="heading" class="margin-none" aria-level="1">Referral Details</p>
          </div>
      </div>
      
      <div class="row HmsInsideContainer">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <app-json-preview [controlsData]="referralFormData.controls">
            </app-json-preview>
        </div>
      </div>
      
      <div class="row HmsInsideContainer">
          <div class="col-md-12">
              <p role="heading" class="margin-none" aria-level="1">Primary Involved Party</p>
          </div>
      </div>
      
      <div class="row HmsInsideContainer">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <app-json-preview [controlsData]="involvedPartyControl">
            </app-json-preview>
            <app-json-preview [controlsData]="externalReferalFormData">
            </app-json-preview>
            <app-json-preview [controlsData]="additionalFormData" *ngIf="externalReferalFormData[0].value == 'Yes'">
            </app-json-preview>
            <app-json-preview [controlsData]="primaryInvolvedPartyControls">
            </app-json-preview>
        </div>
      </div>
      
      <ng-container *ngFor="let involvedPary of additionalInvolvedPartyList">
        <div class="row HmsInsideContainer">
            <div class="col-md-12">
                <p role="heading" class="margin-none" aria-level="1">Additional Involved Party</p>
            </div>
        </div>
        
        <div class="row HmsInsideContainer">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" >
              <app-json-preview [controlsData]="involvedPary.involvedPartyControl">
              </app-json-preview>
              <app-json-preview [controlsData]="involvedPary.externalReferalFormData">
              </app-json-preview>
              <app-json-preview [controlsData]="involvedPary.additionalFormData" *ngIf="involvedPary.externalReferalFormData[0].value == 'Yes'">
              </app-json-preview>
              <app-json-preview [controlsData]="involvedPary.involvedPartyControlDetails">
              </app-json-preview>
          </div>
        </div>
      </ng-container>
      <div class="row HmsInsideContainer">
          <div class="col-md-12">
              <p role="heading" class="margin-none" aria-level="1">Questions and Attachment</p>
          </div>
      </div>
      
      <div class="row HmsInsideContainer">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <app-json-preview *ngIf="questionsFormData && questionsFormData.controls && questionsFormData.controls.length > 0"
                        [controlsData]="questionsFormData.controls"  [controlWidth]="true" [isQuePage]="true"
                        [customClass]="'controlPadding'">
            </app-json-preview>
        </div>
      </div>
      
      <div class="row HmsInsideContainer" >
          <div class="col-md-12" *ngFor="let item of uploadFiles">
              <p class="margin-none">{{item}}</p>
          </div>
          
        <app-upload-file *ngIf="IsUploadAttatchment" [showUploadSection]="false"></app-upload-file>
      </div>
      
      <div class="row HmsInsideContainer">
        <div class="col-md-2">
          <button
            type="submit"
            class="orangeBtn" [disabled]="submitClicked"
            [ngStyle]="{'background-color': !submitClicked ? primaryColor : 'gray'}"
          >
            Submit Referral
          </button>
        </div>
      </div>
    </div>
  </form>
